import React, { type PropsWithChildren } from 'react';

interface ReferenceAhaKnowledgeBaseLinkProps {
  element: any;
}

const ReferenceAhaKnowledgeBaseLink = ({
  element,
  children,
}: PropsWithChildren<ReferenceAhaKnowledgeBaseLinkProps>) => {
  // Disabling this eslint rule as we know page data is available here.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const { pages, references } = window.knowledgeBasePageData!;
  const pageId = element.reference_id || references[element.reference_num];

  const page = pages[pageId];

  // If we couldn't find the name then it must be a link outside the KB.
  if (!page) {
    return (
      <a href={element.reference_url}>
        {element.reference_num}{' '}
        <i className='far fa-arrow-up-right-from-square' />
        {children}
      </a>
    );
  } else {
    const kbPath = $('meta[name=knowledge-base-path]').attr('content');
    const url = `${kbPath}/${page.path}~${pageId}`;

    return (
      <aha-link>
        <a href={url}>{page.name}</a>
      </aha-link>
    );
  }
};

export default ReferenceAhaKnowledgeBaseLink;
